/**
 * joinMC 插码 和百度统计注入
 */
export function inertScript() {
  const NODE_ENV = process.env.NODE_ENV;
  const excludePath = ["/chatBotInsertion", "/chatBotInsertError"]; // 不展示joinmc 插码，需插入单独的百度统计

  const currentPath = window.location.pathname;
  const globalBdScript = !excludePath.includes(currentPath);
  const checkCurrentLocation = () => {
    // 根据 URL 判断是否显示 iframe
    const tipElement = document.getElementById("tip_joinmchat_www");
    const iframeElement = document.getElementById("inframe_container");
    if (globalBdScript) {
      if (tipElement) tipElement.style.display = "block";
      if (iframeElement && iframeElement.style.display === "block") iframeElement.style.display = "block";
    } else {
      if (tipElement) tipElement.style.display = "none";
      if (iframeElement) iframeElement.style.display = "none";
    }
  };
  window.addEventListener("popstate", function (event) {
    checkCurrentLocation();
  });
  const mods = ["production"];
  const HOST = window.location.host;
  if (mods.includes(NODE_ENV)) {
    if (globalBdScript) {
      if (HOST === 'joinmc.cn') {
        window.JoinMChatBotConfig = {
          baseURL: "https://gc.pandarocket.cn/",
          wwwBaseURL: "https://joinmc.cn",
          pageId: "90f7599877fc4e699d27b2801e497fbe",
          csId: "26bc850f29de469d8082ff2de483e770"
        };
      } else {
        // 这里指的是 joincompassai.com
        window.JoinMChatBotConfig = {
          baseURL: "https://gc.pandarocket.cn/",
          wwwBaseURL: "https://joinmc.cn",
          pageId: "4768cafdaa104c75b1fd33fc3cf30f04",
          csId: "095925da99ff4e0d83bc696279054077"
        };
      }
      let st = document.createElement("script");
      st.type = "module";
      st.async = true;
      st.src = "https://joinmc.cn/iframe.js";
      let header = document.getElementsByTagName("head")[0];
      header.appendChild(st);
      var _hmt = _hmt || [];
      (function () {
        let hm = document.createElement("script");
        // hm.src = "https://hm.baidu.com/hm.js?ad9d540f2174b878cf0451bfb8a60d41";
        hm.src = "https://hm.baidu.com/hm.js?d0d23e67fc83bb251ade89d690021e8c";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }
  }
}